<script>
import { mapState, mapGetters, mapActions } from "vuex";
import numberMixin from "@/mixins/numberMixin";

export default {
  data() {
    return {
      preloader: false
    };
  },
  mixins: [numberMixin],
  computed: {
    ...mapState("newOrder", ["to_be", "price", "price_confirmed"]),
    ...mapGetters("newOrder", ["duration"])
  },

  methods: {
    ...mapActions("newOrder", [
      "searchProfessionalsAvailable",
      "setPriceConfirmed"
    ]),
    async search() {
      this.preloader = true;

      try {
        await this.searchProfessionalsAvailable();
        this.setPriceConfirmed(true);
        this.$emit("scrollTo", "#professionals");
      } catch (e) {}

      this.preloader = false;
    },

    confirm() {
      this.setPriceConfirmed(true);
      this.$emit("scrollTo", "#additional-informations");
    }
  }
};
</script>

<template>
  <div class="section">
    <div class="preview-schedule">
      {{ duration }} HORAS DE LIMPEZA POR
      <span>{{ price | intToCurrency }}</span>
      <p>
        Produtos de limpeza, transporte e alimentação do profissional inclusos.
      </p>
    </div>

    <div
      v-if="to_be === 'schedule'"
      class="btn bg-pink"
      :class="{ 'btn--loading': preloader }"
      @click="search"
    >
      <span>buscar</span>
    </div>
    <div
      v-else
      class="btn"
      :class="{
        'bg-pink': !price_confirmed,
        'bg-pink-outline': price_confirmed
      }"
      @click="confirm"
    >
      <span v-if="!price_confirmed">confirmar</span>
      <span v-else>confirmado</span>
    </div>
  </div>
</template>

<style scoped>
.preview-schedule {
  font-size: 20px;
  font-weight: 600;
  margin-top: 20px;
  text-align: center;
}

.preview-schedule span,
.preview-schedule p {
  margin-top: 5px;
  color: var(--pink);
}

.preview-schedule p {
  font-size: 12px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/ConfirmPeriodAndPrice.vue